import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Header, Icon, Card, Button } from 'semantic-ui-react';
import Map from '../../atoms/Map';
import OutboundLink from '../../atoms/OutboundLink';
import Phone from '../../components/Phone/Phone';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../modules/analytics/components/Event';
import { getFormattedAddress, createAddressComponents } from '../../modules/locations/components/LocationName/LocationName.utils';
import { AddressPropType } from '../../services/proptypes';
import ContactElement from '../ContactElement';
import Email from '../Email/Email';
import HoursOfOperation from '../HoursOfOperation';
import IconElement from '../IconElement';
import './location-as-card.css';
var Location = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Location, _React$PureComponent);
  var _super = _createSuper(Location);
  function Location() {
    _classCallCheck(this, Location);
    return _super.apply(this, arguments);
  }
  _createClass(Location, [{
    key: "createMapLink",
    value: function createMapLink(type) {
      var _this$props = this.props,
        businessName = _this$props.businessName,
        address = _this$props.address;
      var formattedAddress = getFormattedAddress(address, false);

      // Link constants
      var linkBase = 'https://www.google.com/maps/search/?api=1&query=';
      var embedBase = 'https://maps.google.com/maps?q=';
      var embedTail = '&t=&z=13&ie=UTF8&iwloc=&output=embed';

      // Address query
      var query = encodeURIComponent(businessName ? "".concat(businessName, " ").concat(formattedAddress) : formattedAddress);

      // Construct link
      if (type === 'link') return "".concat(linkBase).concat(query);
      return "".concat(embedBase).concat(query).concat(embedTail);
    }
  }, {
    key: "generateHumanReadableDistance",
    value: function generateHumanReadableDistance() {
      var _this$props2 = this.props,
        distance = _this$props2.distance,
        distanceUnit = _this$props2.distanceUnit;
      return distance && "".concat(distance.toFixed(2), " ").concat(distanceUnit === 'M' ? ' miles' : 'km', " away");
    }
  }, {
    key: "renderAddress",
    value: function renderAddress() {
      var _this$props3 = this.props,
        as = _this$props3.as,
        phone = _this$props3.phone,
        email = _this$props3.email,
        link = _this$props3.link,
        businessName = _this$props3.businessName,
        distance = _this$props3.distance,
        name = _this$props3.name,
        hours = _this$props3.hours,
        timezone = _this$props3.timezone,
        showBusinessName = _this$props3.showBusinessName,
        showAddress = _this$props3.showAddress,
        iconPosition = _this$props3.iconPosition,
        showIcon = _this$props3.showIcon,
        className = _this$props3.className,
        buttonColor = _this$props3.buttonColor,
        fluidButton = _this$props3.fluidButton,
        buttonText = _this$props3.buttonText,
        buttonSize = _this$props3.buttonSize,
        inline = _this$props3.inline,
        actions = _this$props3.actions,
        address = _this$props3.address;
      if (!showAddress) return '';

      // Button values
      var additionalButtonProps = {
        buttonColor: buttonColor,
        fluidButton: fluidButton,
        buttonSize: buttonSize
      };

      // Address values
      var _createAddressCompone = createAddressComponents(address),
        street = _createAddressCompone.street,
        locality = _createAddressCompone.locality,
        country = _createAddressCompone.country;
      if (as === 'card') {
        var linkProps = {};
        linkProps.href = this.createMapLink('link');
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
        return /*#__PURE__*/React.createElement(Card, {
          fluid: true,
          className: "location-as-card"
        }, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Card.Header, null, name || street), /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "map"
        })), /*#__PURE__*/React.createElement("div", null, street, /*#__PURE__*/React.createElement("br", null), locality, country && ", ".concat(country))), phone && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "phone"
        })), /*#__PURE__*/React.createElement("div", null, phone)), email && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "mail"
        })), /*#__PURE__*/React.createElement("div", null, email)), hours && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "calendar outline"
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HoursOfOperation, {
          hours: hours,
          timezone: timezone,
          displayOption: "dailyWithPopup"
        }))), distance && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "world"
        })), /*#__PURE__*/React.createElement("div", null, this.generateHumanReadableDistance()))), /*#__PURE__*/React.createElement(Card.Content, {
          style: {
            display: 'flex',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/React.createElement(Button, {
          secondary: true,
          as: OutboundLink,
          to: linkProps.href,
          icon: "map",
          content: "Directions"
        }), phone && /*#__PURE__*/React.createElement(Button, {
          secondary: true,
          as: OutboundLink,
          to: "tel:".concat(phone),
          icon: "phone",
          content: "Call"
        }), email && /*#__PURE__*/React.createElement(Button, {
          secondary: true,
          as: OutboundLink,
          to: "mailto:".concat(email),
          icon: "mail",
          content: "Email"
        }), actions.map(function (_ref) {
          var icon = _ref.icon,
            url = _ref.url,
            label = _ref.label;
          return /*#__PURE__*/React.createElement(Button, {
            secondary: true,
            as: OutboundLink,
            to: url,
            icon: icon,
            content: label
          });
        })));
      }
      if (as === 'text') {
        var plainHeader = /*#__PURE__*/React.createElement("div", {
          className: "location-container"
        }, businessName && showBusinessName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, businessName), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(OutboundLink, {
          event: {
            category: EVENT_CATEGORIES.LOCATION_EVENT_CATEGORY,
            action: EVENT_ACTIONS.LOCATION_VIEW_LOCATION_ADDRESS_EVENT_ACTION,
            label: street
          },
          to: this.createMapLink('link')
        }, /*#__PURE__*/React.createElement("span", null, street, !inline && /*#__PURE__*/React.createElement("br", null), inline && locality && ", ", locality, country && ", ".concat(country))), phone && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Phone, {
          phone: phone
        })), email && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Email, {
          email: email
        })), link && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
          href: link.url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: link.icon
        }), link.title)), distance && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, this.generateHumanReadableDistance())));
        return showIcon ? /*#__PURE__*/React.createElement(IconElement, {
          iconType: "map marker alternate",
          iconPosition: iconPosition,
          element: plainHeader
        }) : plainHeader;
      }

      // If not displaying the address, display as a button
      return /*#__PURE__*/React.createElement(ContactElement, _extends({
        contact: buttonText,
        link: this.createMapLink('link'),
        iconType: "map marker alternate",
        as: buttonText === '' ? 'icon' : 'button',
        className: className,
        content: buttonText
      }, additionalButtonProps));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var header = this.props.header;
      return /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement(Header, {
        as: "h2"
      }, header));
    }
  }, {
    key: "renderMap",
    value: function renderMap() {
      var _this$props4 = this.props,
        address = _this$props4.address,
        businessName = _this$props4.businessName;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/React.createElement(Map, {
        address: address,
        businessName: businessName
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        showMap = _this$props5.showMap,
        header = _this$props5.header,
        _this$props5$showAddr = _this$props5.showAddress,
        showAddress = _this$props5$showAddr === void 0 ? true : _this$props5$showAddr;
      return /*#__PURE__*/React.createElement(React.Fragment, null, header !== '' && this.renderHeader(), showAddress && this.renderAddress(), showMap && this.renderMap());
    }
  }]);
  return Location;
}(React.PureComponent);
export { Location as default };
Location.defaultProps = {
  as: 'text',
  businessName: '',
  showBusinessName: true,
  name: '',
  className: '',
  phone: null,
  email: null,
  link: null,
  hours: null,
  distance: null,
  timezone: '',
  distanceUnit: 'M',
  buttonColor: 'default',
  buttonSize: 'large',
  buttonText: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showAddress: true,
  showIcon: false,
  showMap: false,
  inline: false,
  actions: []
};
Location.propOptions = {
  buttonColor: ['primary', 'secondary', 'default'],
  header: ['Location', 'Our Location', ''],
  iconPosition: ['left', 'right', 'top', 'bottom']
};
Location.dataPropsMap = {
  address: ['business', 'primary_location', 'address'],
  // check this one
  businessName: ['business', 'primary_location', 'name']
};